import http from 'hub-http/clients/apiClient';
import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
export function fetchJourneyTrackingPropertyDefinition(crmObject) {
  const journeyTrackingPropertyName = getPropertyValue(crmObject, 'hs_journey_tracking_property');

  // useFetch expects a Promise, but we want to skip the api call and return undefined if there is no tracking property definition
  if (!journeyTrackingPropertyName) {
    return new Promise(resolve => resolve(undefined));
  }
  return http.get(`properties/v4/0-1/named/${journeyTrackingPropertyName}`).then(response => response ? response.property : undefined);
}